import axios from "../../../utils/axios";
import { handleRemoveEmptyParamFromQueryParams } from "../../../utils/helpers";
import {
    ICreateNoteRuleBypassPayload,
    INoteRuleBypassFilters,
    IProviderClientsForBypassFilters,
    IUpdateNoteRuleBypassStatusPayload,
} from "../types/note-rule-bypass.types";

export async function fetchNoteRuleBypasses(filters: INoteRuleBypassFilters) {
    const response = await axios.get(`/note-rule-bypass`, {
        params: handleRemoveEmptyParamFromQueryParams(filters),
    });
    return response.data;
}

export async function createNoteRuleBypass(
    payload: ICreateNoteRuleBypassPayload
) {
    const response = await axios.post(`/note-rule-bypass`, payload);
    return response.data;
}

export async function updateNoteRuleBypassStatus({
    bypass_id,
    status,
}: IUpdateNoteRuleBypassStatusPayload) {
    const response = await axios.patch(
        `/note-rule-bypass/${bypass_id}/status`,
        { status }
    );
    return response.data;
}

export async function fetchClientsForNoteRuleBypass({
    provider_id,
    ...filters
}: IProviderClientsForBypassFilters) {
    const response = await axios.get(
        `/note-rule-bypass/provider/${provider_id}/clients`,
        { params: handleRemoveEmptyParamFromQueryParams(filters) }
    );
    return response.data;
}
